'use client'

import Link from '@/modules/shared/components/Link'

interface SmoothScrollLinkProps {
    href: string
    className?: string
    children: React.ReactNode
}

export default function SmoothScrollLink({
    href,
    className,
    children,
}: SmoothScrollLinkProps) {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Only handle hash links
        if (href.startsWith('#')) {
            e.preventDefault()
            const targetId = href.substring(1)
            const targetElement = document.getElementById(targetId)

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })

                // Update URL hash without jumping
                window.history.pushState(null, '', href)
            }
        }
    }

    return (
        <Link href={href} className={className} onClick={handleClick}>
            {children}
        </Link>
    )
}
